module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-preface004"
    }
  }, [_vm._v("MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter002#map1"
    }
  }, [_vm._v("Abyssinia and Sudan")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Danakil expedition, 1933–34")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rub’ al Khali, or Empty Quarter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The marshes of Iraq")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afghanistan and Pakistan")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chitral and Hunza")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hazarajat and Waziristan")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nuristan and Badakhshan")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#map9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iran and Iraq")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#map10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Yemen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#map11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kenya")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("(The marking of international boundaries is not authoritative)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c20ec9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface004.vue
// module id = 75
// module chunks = 0